import { ContractWithLinks, getContractsEndpoint } from 'common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-10/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData } = getSimpleDataFetchSlice<ContractWithLinks[], DefaultBusinessMarketApiErrorCode>({
    dataName: 'contracts',
    fetchCallback() {
        return CpDataApi.get(getContractsEndpoint()).then((response) => response.data);
    },
});

export default reducer;
export const fetchContracts = fetchData;
